import { $t } from "@/lib/helpers/i18nHelper";

const MUTATION_TYPES = Object.freeze({
  STORE_DATA: "STORE_DATA",
  CLEAR_DATA: "CLEAR_DATA",
  ADD_DATA: "ADD_DATA",
  DEL_DATA: "DEL_DATA",
  SET_DATA: "SET_DATA",
});

const ACTION_TYPES = Object.freeze({
  SET_DATA: "SET_DATA",
  GET_DATA: "GET_DATA",
  ADD_DATA: "ADD_DATA",
  DEL_DATA: "DEL_DATA",
  SEARCH: "SEARCH",
});

const TEXT = Object.freeze({
  FIELD_EMPTY: $t("Field is empty"),
  FIELDS_EMPTY: $t("Fields are empty"),
  AUTH_FAILED: $t("Authorization error"),
  FRAUD: {
    POSSIBLE: $t("Detected fraud activity"),
    FRAUD: $t("User is fraud"),
    PASSED: $t("Passed fraud review"),
    UNKNOWN: $t("Fraud not detected"),
  },
  QUESTIONARY: {
    GENDER: {
      MALE: $t("Male"),
      FEMALE: $t("Female"),
    },
    BODY: {
      PETITE: $t("Petite"),
      NORMAL: $t("Normal"),
      ATHLETIC: $t("Athletic"),
      THICK: $t("Thick"),
    },
    ETHNICITY: {
      WHITE: $t("White"),
      HISPANIC: $t("Hispanic"),
      LATINA: $t("Latina"),
      BLACK: $t("Black"),
      MIDDLE_EASTERN: $t("Middle Eastern"),
      ASIAN: $t("Asian"),
      PACIFIC_ISLANDER: $t("Pacific Islander"),
      MIXED: $t("Mixed"),
    },
    ORIENTATION: {
      STRAIGHT: $t("Straight"),
      GAY: $t("Gay"),
      LESBIAN: $t("Lesbian"),
      BISEXUAL: $t("Bisexual"),
      TRANSSEXUAL: $t("Transsexual"),
    },
    HAIR_LENGTH: {
      BALD: $t("Bald"),
      SHORT: $t("Short"),
      SHOULDER_LENGTH: $t("Shoulder Length"),
      LONG: $t("Long"),
      VERY_LONG: $t("Very Long"),
    },
    HAIR_COLOR: {
      BLONDE: $t("Blonde"),
      HONEY_BLONDE: $t("Honey Blonde"),
      BROWN: $t("Brown"),
      HIGHLIGHTS: $t("Highlights"),
      BLACK: $t("Black"),
      DYED: $t("Dyed"),
      OTHER: $t("Other"),
    },
    EYE_COLOR: {
      BLUE: $t("Blue"),
      GREEN: $t("Green"),
      BROWN: $t("Brown"),
      HAZEL: $t("Hazel"),
      GREY: $t("Grey"),
    },
  },
});

const EVENTS = Object.freeze({
  LOADING: {
    CHANGE: "LOADING_CHANGE",
  },
  STATUS_NOTIFICATIONS: {
    HIDE_ALL: "STATUS_NOTIFICATIONS_HIDE_ALL",
  },
});

export { MUTATION_TYPES, ACTION_TYPES, TEXT, EVENTS };
